import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { QUICKSTART_TYPE } from '../../common/constants.tsx';
import type { State } from './types.tsx';

// These selectors are used by actions - we can't define them in ../index.tsx file because of circular dependencies

export const isJsmProjectSelector = (state: State) =>
	state.projectState?.projectType === SERVICE_DESK_PROJECT;

export const getQuickstartTypeSelector = (state: State) => {
	if (isJsmProjectSelector(state)) {
		return QUICKSTART_TYPE.JSM_BUSINESS_QUICKSTART_KEY;
	}
	return QUICKSTART_TYPE.OLD_GLOBAL_QUICKSTART_KEY;
};
